import { defineNuxtPlugin } from '#app/nuxt'
import { LazyPropseUl, LazyProseP, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["PropseUl", LazyPropseUl],
["ProseP", LazyProseP],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
